import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const propertyCardStyles = makeStyles((theme) => ({
    root: {
        borderBottom: "1px solid #E4E8EE",
        backgroundColor: "white",
        padding: "8px 12px",
        cursor: "pointer"
    },
    img: {
        height: "100px",
        width: "100%",
        borderRadius: theme.palette.borderRadius,
        objectFit: "cover"
    },
    title: {
        fontSize:"1rem",
        color: "#091B29",
        fontFamily: FontFamilySwitch().bold,
        textTransform: "capitalize"
    },
    address: {
        fontSize:"0.875rem",
        color: "#98A0AC",
        fontFamily: FontFamilySwitch().regular,
        textTransform: "capitalize",
        marginTop: "2px"
    },
    build: {
        fontSize:"0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().bold,
    },
    build1: {
        fontSize:"0.75rem",
        color: "#98A0AC",
        fontFamily: FontFamilySwitch().regular,
    },
    availabe: {
        fontSize:"0.75rem",
        color: "#5AC782",
        fontFamily: FontFamilySwitch().bold,
        backgroundColor: "#EEF9EE",
        padding: "2px 8px",
        borderRadius: theme.palette.borderRadius,
        display: "inline-block",
        marginTop: "10px"
    },
    imgDiv: {
        position: "relative",
    },
    type: {
        position: "absolute",
        bottom: "7px",
        left: "0px",
        right: "0px",
        textAlign: "center",
        backgroundColor: "#071741",
        color: "white",
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        padding: "4px 0px",
        borderRadius: `0px 0px ${theme.palette.borderRadius} ${theme.palette.borderRadius}`,
    }
}));